<template>
  <sf-alert-base :icon="mdiCheckCircleOutline" type="success">
    <slot />
  </sf-alert-base>
</template>

<script setup lang="ts">
import SfAlertBase from '@/components/alerts/SfAlertBase.vue'

import { mdiCheckCircleOutline } from '@mdi/js'
</script>
